module.exports = __webpack_public_path__ + "static/media/DSCF6484.43eee8dc.JPG";